var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ECECEC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162_92414",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162_92414)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5593,
    cy: 10.905,
    r: 6.23902,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5417 31.4154C30.5417 39.297 23.4353 32.8497 15.5537 32.8497C7.67215 32.8497 2 39.297 2 31.4154C2 23.5338 8.38928 17.1445 16.2709 17.1445C24.1524 17.1445 30.5417 23.5338 30.5417 31.4154Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.670f498df3428409f8801ea70062768b.svg";
export { ForwardRef as ReactComponent };